import { useQuery } from "react-query";
import { getTaskTypeRejectReason } from "../../../components/task-list/lib/taskData";
import { TaskType } from "../../taskTypeMap";

export const useTaskTypeRejectReason = (containsSampleUpc) => {
    return useQuery({
        queryKey: ["task-type-reject-reason"],
        queryFn: getTaskTypeRejectReason,
        select: (data) => {
            if (!containsSampleUpc) {
                return data;
            }

            const { [TaskType.CODING_QA]: _, ...reasons } = data;

            return reasons;
        },
    });
};
